/* HAUS Cologne PDP — interactions. Vanilla, scoped per section root (.cpdp).
   Modular: hero / buybox / story each mount their own .cpdp root.
   Progressive enhancement: no-JS leaves content visible and the buybox form
   posts normally to the cart. */
(function () {
  function cartAdd(root, id, onErr) {
    var addUrl = (root.getAttribute('data-add-url') || '/cart/add') + '.js';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var body = new FormData();
    body.append('id', id);
    body.append('quantity', 1);
    fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) { if (!res.ok) throw new Error((res.j && res.j.description) || 'add failed'); window.location.href = cartUrl; })
      .catch(function () { if (onErr) onErr(); window.location.href = cartUrl; });
  }

  function initRoot(root) {
    if (!root || root.dataset.cpdpInit) return;
    root.dataset.cpdpInit = '1';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var motion = root.dataset.motion === 'true' && !reduce;
    if (motion) root.classList.add('cpdp--motion');

    /* ---- scroll reveal ---- */
    var reveals = Array.prototype.slice.call(root.querySelectorAll('[data-reveal]'));
    if (motion && 'IntersectionObserver' in window && reveals.length) {
      var ro = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-shown'); ro.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
      reveals.forEach(function (el) { ro.observe(el); });
      setTimeout(function () { reveals.forEach(function (el) { el.classList.add('is-shown'); }); }, 4000);
    } else {
      reveals.forEach(function (el) { el.classList.add('is-shown'); });
    }

    /* ---- dry-down intensity bars ---- */
    var movs = Array.prototype.slice.call(root.querySelectorAll('[data-mv]'));
    if ('IntersectionObserver' in window && movs.length) {
      var bo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var bar = e.target.querySelector('[data-bar]');
          if (bar) bar.style.width = (e.target.getAttribute('data-intensity') || '80') + '%';
          bo.unobserve(e.target);
        });
      }, { threshold: 0.35 });
      movs.forEach(function (el) { bo.observe(el); });
    } else {
      movs.forEach(function (el) { var bar = el.querySelector('[data-bar]'); if (bar) bar.style.width = (el.getAttribute('data-intensity') || '80') + '%'; });
    }

    /* ---- sticky mini ATC: docks below the header. Shows over the hero and
       again after the buy box; hides while the native buy box (main-product)
       is on screen since you can add to cart there. ---- */
    var sticky = root.querySelector('[data-sticky]');
    if (sticky) {
      var headerEl = document.querySelector('.shopify-section--header') || document.querySelector('.header');
      var buyBox = document.querySelector('.shopify-section--main-product');
      var footer = document.querySelector('.shopify-section--footer');
      var rafPending = false;
      var buyInView = false;
      var footerInView = false;
      var update = function () {
        rafPending = false;
        var hb = headerEl ? Math.max(0, headerEl.getBoundingClientRect().bottom) : 0;
        sticky.style.top = hb + 'px';
        // show only between the buy box and the footer (hide on both)
        sticky.classList.toggle('is-stuck', !buyInView && !footerInView);
      };
      if ('IntersectionObserver' in window) {
        if (buyBox) new IntersectionObserver(function (entries) {
          buyInView = entries[0].isIntersecting;
          if (!rafPending) { rafPending = true; requestAnimationFrame(update); }
        }, { threshold: 0 }).observe(buyBox);
        if (footer) new IntersectionObserver(function (entries) {
          footerInView = entries[0].isIntersecting;
          if (!rafPending) { rafPending = true; requestAnimationFrame(update); }
        }, { threshold: 0 }).observe(footer);
      }
      var onScroll = function () { if (!rafPending) { rafPending = true; requestAnimationFrame(update); } };
      update();
      // enable the slide transition only after the initial position is painted (no pop-in on load)
      requestAnimationFrame(function () { requestAnimationFrame(function () { sticky.classList.add('cpdp-sticky--ready'); }); });
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }

    /* ---- hero scroll-down arrow ---- */
    root.querySelectorAll('[data-scroll-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var headerEl = document.querySelector('.shopify-section--header') || document.querySelector('.header');
        var hb = headerEl ? Math.max(0, headerEl.getBoundingClientRect().bottom) : 0;
        var section = root.closest('.shopify-section');
        var target = document.querySelector('.cologne-buybox-section') || (section && section.nextElementSibling);
        if (target) {
          window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - hb, behavior: 'smooth' });
        } else {
          window.scrollBy({ top: window.innerHeight * 0.85, behavior: 'smooth' });
        }
      });
    });

    /* ---- accordions (single-open: opening one closes the others in its group) ---- */
    root.querySelectorAll('.cpdp-acc__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var acc = btn.closest('.cpdp-acc'); if (!acc) return;
        var willOpen = !acc.classList.contains('is-open');
        var group = acc.closest('.cpdp-acc-wrap') || root;
        group.querySelectorAll('.cpdp-acc.is-open').forEach(function (other) {
          if (other === acc) return;
          other.classList.remove('is-open');
          var ob = other.querySelector('.cpdp-acc__btn');
          if (ob) ob.setAttribute('aria-expanded', 'false');
        });
        acc.classList.toggle('is-open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    /* ---- gallery swap (buybox root) ---- */
    var mainImg = root.querySelector('[data-gallery-main]');
    var capEl = root.querySelector('[data-gallery-cap]');
    root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-img'); var cap = thumb.getAttribute('data-cap') || '';
        if (mainImg && src) { mainImg.src = src; mainImg.alt = thumb.getAttribute('data-alt') || mainImg.alt; }
        if (capEl) capEl.textContent = cap;
        root.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* ---- best-sellers carousel ---- */
    var track = root.querySelector('[data-car]');
    var prev = root.querySelector('[data-car-prev]');
    var next = root.querySelector('[data-car-next]');
    if (track && prev && next) {
      prev.addEventListener('click', function () { track.scrollBy({ left: -340, behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: 340, behavior: 'smooth' }); });
    }

    /* ---- ADD TO CART ---- */
    // Primary: native buybox form (AJAX-enhanced; posts normally if JS off)
    var form = root.querySelector('form.cpdp-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var id = new FormData(form).get('id'); if (!id) return;
        var lbl = form.querySelector('[data-atc-label]'); if (lbl) lbl.textContent = 'ADDING...';
        cartAdd(root, id);
      });
    }
    // Shortcuts: sticky bar + closing CTA (add the single variant by id)
    root.querySelectorAll('[data-atc-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-variant-id'); if (!id) return;
        var lbl = b.querySelector('[data-atc-label]'); if (lbl) lbl.textContent = 'ADDING...';
        cartAdd(root, id);
      });
    });
  }

  function boot() { document.querySelectorAll('.cpdp').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // register editor hook once even if the script is included by several sections
  if (!window.__cpdpHook) {
    window.__cpdpHook = 1;
    document.addEventListener('shopify:section:load', function (e) {
      (e.target.querySelectorAll ? e.target.querySelectorAll('.cpdp') : []).forEach(initRoot);
    });
  }
})();
